import { createFileRoute } from "@tanstack/react-router";
import Testimonials from "@/pages/Testimonials";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/testimonials")({
  head: () =>
    seo({
      title: "Customer Reviews & Testimonials | Cedar Creek Construction",
      description:
        "Read Google reviews from Minnesota homeowners who hired Cedar Creek Construction for roofing, siding, decks, and gutter work across the Twin Cities.",
      path: "/testimonials",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Testimonials", path: "/testimonials" },
      ]),
    }),
  component: Testimonials,
});
